import { Suspense, useEffect, useRef } from "react";
import { RouterProvider } from "react-router-dom";
import { Toast } from "primereact/toast";

import "./App.css";
import routes from "./routes/routes";
import AppErrorBoundary from "./components/common/AppErrorBoundary";
import { logMessage } from "./utils/logMessage";
import { socket } from "./utils/socket";
import { SOCKET_EVENTS } from "./utils/socketEvents";

function App() {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    socket.connect();

    socket.on("connect", () => {
      logMessage("Connected to WebSocket server");
    });

    socket.on("disconnect", () => {
      logMessage("Disconnected from WebSocket server");
    });

    socket.on(SOCKET_EVENTS.TRANSACTION_SUCCESS, (data) => {
      toastRef.current?.show({
        severity: "success",
        summary: "Transaction paid",
        detail: `Transaction with code: ${data.code} has been paid.`,
        life: 5000,
      });
    });

     socket.on(SOCKET_EVENTS.TRANSACTION_FAILED, (data) => {
      toastRef.current?.show({
        severity: "error",
        summary: "Transaction Failed",
        detail: `Transaction with code: ${data.code} failed.`,
        life: 5000,
      });
    });

    socket.on(SOCKET_EVENTS.TRANSACTION_PENDING, (data) => {
      toastRef.current?.show({
        severity: "info",
        summary: "Transaction Pending",
        detail: `Transaction with code: ${data.code} is in progress.`,
        life: 5000,
      });
    });


    return () => {
      socket.disconnect();
    };
  }, []);

  

  return (
    <AppErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <Toast ref={toastRef} />
        <RouterProvider router={routes} />
      </Suspense>
    </AppErrorBoundary>
  );
}

export default App;
